
import Vue from "vue";
import ExpansionPanelTemplate from "@/components/common/ExpansionPanelTemplate.vue";

export default Vue.extend({
  name: "Faqs",
  components: { ExpansionPanelTemplate },
  props: {
    faqs: { type: Array, default: () => [] },
  },
});
